import axios from "axios";

export default {
    sendPasswordReminder: async (email) => {
        await axios.post(`/auth/password/reminder/`, {
            email
        })
    },
    resetPassword: async(email, hash, password) => {
        await axios.post(`/auth/password/reset/`, {
            email,
            h: hash,
            new_password: password
        })
    }
}
